<template>
    <v-container class="grey-lighten-3 full-height">
        <!-- Action Toolbar (Hidden on Print) -->
        <v-row class="d-print-none mb-4" justify="center">
            <v-col cols="12" md="8" lg="9" class="d-flex justify-center gap-2">
                <v-btn color="success" prepend-icon="mdi-download" @click="downloadPDF">
                    Download PDF
                </v-btn>
            </v-col>
        </v-row>

        <!-- Printable Area -->
        <v-row justify="center">
            <v-col cols="12" xl="10" lg="11" md="12">
                <v-sheet class="report-paper pa-5 mx-auto" elevation="3" id="printable-area">

                <div class="header-section d-flex justify-space-between mb-6 lines">
                    <div class="company-logo-area d-flex align-center">
                    <!-- Replace with actual logo -->
                        <div class="logo-placeholder mr-4">
                            <!-- <v-icon icon="mdi-domain" size="40" color="grey-darken-2"></v-icon> -->
                        </div>
                        <div>
                            <v-img
                            :src="`${getFileServerUrl.replace(/\/$/, '')}/${getPassData?.branch?.company?.logo || 'uploads/demo_images/user.png'}`"
                            width="200" height="100" class="rounded" />
                        </div>
                    </div>

                    <div class="company-address text-caption text-right">
                        <h1 class="company-name text-h5 font-weight-bold text-uppercase">
                            {{ getPassData?.branch?.company?.name }}
                        </h1>
                        <h1 class="text-subtitle-1 text-end">
                            {{ getPassData?.branch?.company?.address }}
                        </h1>
                    </div>
                </div>

                <!-- Title -->
                <div class="text-center mb-6">
                    <h2 class="report-title text-h6 font-weight-bold text-decoration-underline">
                        Gate Pass Invoice
                    </h2>
                </div>

                <!-- Master Information -->
                <div class="meta-info-box mb-4">
                    <div class="d-flex">
                        <div class="meta-item d-flex align-center" style="width: 50%; border-right: 1px solid #000; border-bottom:1px solid #000">
                            <span class="meta-label pl-2">Gate Pass Code:</span>
                            <span class="meta-value pl-2 font-weight-bold">{{ getPassData?.code }}</span>
                        </div>  
                        <div class="meta-item d-flex align-center" style="width: 50%; border-bottom:1px solid #000">
                            <span class="meta-label pl-2">Gate Pass Date:</span>
                            <span class="meta-value pl-2">{{ getPassData?.gate_pass_date }}</span>
                        </div>
                    </div>
                    <div class="d-flex" style="border-bottom: 1px solid #000;">
                        <div class="meta-item d-flex align-center" style="width: 50%; border-right: 1px solid #000;">
                            <span class="meta-label pl-2">Customer Name:</span>
                            <span class="meta-value pl-2">{{ getPassData?.customer?.company_name }}</span>
                        </div>
                        <div class="meta-item d-flex align-center" style="width: 50%;">
                            <span class="meta-label pl-2">Vehicle No:</span>
                            <span class="meta-value pl-2">{{ getPassData?.vehicle_no || "-" }}</span>
                        </div>
                    </div>
                    <div class="d-flex" style="border-bottom: 1px solid #000;">
                        <div class="meta-item d-flex align-center" style="width: 50%; border-right: 1px solid #000;">
                            <span class="meta-label pl-2">Driver Name:</span>
                            <span class="meta-value pl-2">{{ getPassData?.driver_name || "-" }}</span>
                        </div>
                        <div class="meta-item d-flex align-center" style="width: 50%;">
                            <span class="meta-label pl-2">Mobile No:</span>
                            <span class="meta-value pl-2">{{ getPassData?.mobile_no || "-" }}</span>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="meta-item d-flex align-center" style="width: 50%; border-right: 1px solid #000;">
                            <span class="meta-label pl-2">Transporter Name:</span>
                            <span class="meta-value pl-2">{{ getPassData?.transporter_name || "-" }}</span>
                        </div>
                        <div class="meta-item d-flex align-center" style="width: 50%;">
                            <span class="meta-label pl-2">Remarks:</span>
                            <span class="meta-value pl-2">{{ getPassData?.remarks }}</span>
                        </div>
                    </div>
                </div>

                <!-- Depreciation Details Table -->
                <div class="table-container mb-6">
                    <table class="dep-table">
                        <thead>
                            <tr>
                                <th class="text-center" style="width: 40px;">SL</th>
                                <th>Product Code</th>
                                <th>Product Name</th>
                                <th>Unit</th>
                                <th>Qty</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(detail, index) in getPassData?.details" :key="detail.id">
                                <td class="text-center">{{ index + 1 }}</td>
                                <td class="text-center">{{ detail.product.code }}</td>
                                <td class="text-center">{{ detail.product.name }}</td>
                                <td class="text-center">{{ detail.product.unit.name }}</td>
                                <td class="text-right">{{ detail.qty }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Prepared By Info -->
                <div class="prepared-section mb-8">
                    <div class="font-weight-bold mb-1">Prepared By:</div>
                    <div>{{ getPassData?.created_by?.full_name || '-' }}</div>
                    <div class="text-caption">{{ formatDateTime(getPassData?.created_at) }}</div>
                </div>
                </v-sheet>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
    name: "GatePassInvoice",
    data: () => ({
        mainId: null,
        getPassData: null,
    }),
    
    watch: {},

    created() {
        const id = this.$route.query.id;
        this.mainId = id;
        this.$store.dispatch("getInvGatePassById", id).then((response) => {
            console.log(response)
            this.getPassData = response;
        });
    },
    computed: {
        getFileServerUrl() {
            return this.$store.getters.getFileServerUrl;
        },
    },  

    methods: {
        formatDate(date) {
            if (!date) return "-";
            const d = new Date(date);
            return `${d.getDate().toString().padStart(2, "0")}/${(d.getMonth() + 1)
                .toString()
                .padStart(2, "0")}/${d.getFullYear()}`;
        },
        formatDateTime(dateTime) {
            if (!dateTime) return "-";
            const d = new Date(dateTime);
            return `${this.formatDate(dateTime)} ${d.toLocaleTimeString()}`;
        },
        formatNumber(num) {
            return num ? Number(num).toFixed(2) : "0.00";
        },
        async downloadPDF() {
            const element = document.getElementById("printable-area");
            const opt = {
                margin: [0.5, 0.5],
                filename: `gate-pass-invoice-${this.getPassData?.code}.pdf`,
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 2, useCORS: true },
                jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
            };
            await html2pdf().set(opt).from(element).save();
        },
    },
};
</script>

<style scoped>
.header-section {
    display: flex;
    flex-direction: flex !important;
}
.company-address {
    text-align: left !important;
}
.full-height {
    min-height: 100vh;
}
.grey-lighten-3 {
    background-color: #eeeeee !important;
}
.report-paper {
    background-color: white;
    color: black;
    font-family: 'Times New Roman', serif;
    max-width: 280mm;
    width: 100%;
    min-height: 297mm;
}
.company-name {
    color: #444;
    letter-spacing: 1px;
}
.report-title {
    text-decoration: underline;
    text-underline-offset: 4px;
}
.meta-info-box {
    border: 1px solid #000;
}
.meta-item {
    height: 35px;
}
.meta-label {
    font-weight: 500;
    color: #333;
}
.dep-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}
.dep-table th {
    background-color: #e0e0e0;
    border: 1px solid #000;
    padding: 6px 5px;
}
.dep-table td {
    border: 1px solid #000;
    padding: 6px 5px;
    vertical-align: top;
}
.lines {
    border-bottom: 1px solid #ccc;
    padding-bottom: 5px;
}
.text-center {
    text-align: center;
}
.text-right {
    text-align: right;
}
.gap-2 {
    gap: 8px;
}

/* Print Styles */
@media print {
    body * {
            visibility: hidden;
    }
    #printable-area,
    #printable-area * {
            visibility: visible;
    }
    #printable-area {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        padding: 15px;
    }
    .report-paper {
        box-shadow: none !important;
    }
    @page {
        size: A4 portrait;
        margin: 0.5cm;
    }
    .d-print-none {
        display: none !important;
    }
}

</style>
